import { ActionTree, GetterTree, MutationTree } from "vuex";
import { FirebaseStateType } from "@/types/FirebaseTypes";
import firebase from "firebase";
import { firebaseEnvironmentKey } from "@/utils/FirebaseKeys";

const firebaseConfig = {
  apiKey: "AIzaSyDR7yGghTFp-16FQX0I4xILNP_FbB6IpDA",
  authDomain: "claroflex-prod.firebaseapp.com",
  databaseURL: "https://claroflex-prod.firebaseio.com",
  projectId: "claroflex-prod",
  storageBucket: "claroflex-prod.appspot.com",
  messagingSenderId: "244910085520",
  appId: "1:244910085520:web:ce4708a57168e878ba4f15",
  measurementId: "G-XCN7NYN1GL",
};

if (!firebase.apps.length) {
  firebase.initializeApp(firebaseConfig);
  firebase.analytics();
}

const remoteConfig = firebase.remoteConfig();

remoteConfig.settings.minimumFetchIntervalMillis = 10000;

remoteConfig.fetchAndActivate();

const state: FirebaseStateType = {
  tikTok: [],
  idOrigin: {},
  promoPlan: "",
  isShowSimDelivery: false,
  isMeli: false,
  webView: true,
  vertexParams: {
    url: "https://meuplanoclaro.com.br/flex?utm_source=portal_flex",
    active: false,
    message: "*Válido para São Paulo",
  },
  skeeloCompositionId: [
    "6bd84140-6af8-466a-98b0-a2bc4c2da29d",
    "ea37464f-7006-4852-a3c4-64d48e177a67",
  ],
  flowCollaboratorActive: false,
  blackFriday: {
    active: false,
    plans: [],
  },
  promotionLabel: {
    active: false,
    plans: [],
  },
};

const getters: GetterTree<FirebaseStateType, any> = {
  tiktok: (st) => st.tikTok,
  idOrigin: (st) => st.idOrigin,
  promoPlan: (st) => st.promoPlan,
  isShowSimDelivery: (st) => st.isShowSimDelivery,
  isMeli: (st) => st.isMeli,
  webView: (st) => st.webView,
  vertexParams: (st) => st.vertexParams,
  skeeloCompositionId: (st) => st.skeeloCompositionId,
  flowCollaboratorActive: (st) => st.flowCollaboratorActive,
  blackFriday: (st) => st.blackFriday,
  promotionLabel: (st) => st.promotionLabel,
};

const mutations: MutationTree<FirebaseStateType> = {
  setTikTok(st: FirebaseStateType, tiktok) {
    st.tikTok = tiktok;
  },
  setPromoPlan(st: FirebaseStateType, promoPlan) {
    st.promoPlan = promoPlan;
  },
  setIsShowSimDelivery(st: FirebaseStateType, isShowSimDelivery) {
    st.isShowSimDelivery = isShowSimDelivery;
  },
  setIsMeli(st: FirebaseStateType, isMeli) {
    st.isMeli = isMeli;
  },
  setWebView(st: FirebaseStateType, webView) {
    st.webView = webView;
  },
  setVertexParams(st: FirebaseStateType, vertexParams) {
    st.vertexParams = vertexParams;
  },
  setSkeeloCompositionId(st: FirebaseStateType, skeeloCompositionId) {
    st.skeeloCompositionId = skeeloCompositionId;
  },
  setIdOrigin(st: FirebaseStateType, idOrigin) {
    st.idOrigin = idOrigin;
  },
  setFlowCollaboratorActive(st: FirebaseStateType, flowCollaboratorActive) {
    st.flowCollaboratorActive = flowCollaboratorActive;
  },
  setBlackFriday(st: FirebaseStateType, promo) {
    st.blackFriday = promo;
  },
  setPromotionLabel(st: FirebaseStateType, promotionLabel) {
    st.promotionLabel = promotionLabel;
  },
};

const actions: ActionTree<FirebaseStateType, any> = {
  async setTikTok({ commit }, tiktok) {
    commit("setTikTok", tiktok);
  },
  async setPromoPlan({ commit }, promoPlan) {
    commit("setPromoPlan", promoPlan);
  },
  async setIsShowSimDelivery({ commit }) {
    const firebaseKey = await firebaseEnvironmentKey("sim_delivery_portal");
    const getShowSimDelivery = remoteConfig.getBoolean(firebaseKey);
    commit("setIsShowSimDelivery", getShowSimDelivery);
  },
  async setIsMeli({ commit }, isMeli) {
    commit("setIsMeli", isMeli);
  },
  async setWebView({ commit }, webView) {
    commit("setWebView", webView);
  },
  async getVertexParams({ commit }) {
    const firebaseKey = await firebaseEnvironmentKey("vertex_params");
    const getVertexParams = remoteConfig.getString(firebaseKey);
    commit("setVertexParams", JSON.parse(getVertexParams));
  },
  async setSkeeloCompositionId({ commit }, skeeloCompositionId) {
    commit("setSkeeloCompositionId", skeeloCompositionId);
  },
  async getIdOrigin({ commit }) {
    const firebaseKey = await firebaseEnvironmentKey("id_origin");
    const getIdOriginParams = await remoteConfig.getString(firebaseKey);
    commit("setIdOrigin", JSON.parse(getIdOriginParams));
  },
  async setFlowCollaboratorActive({ commit }): Promise<void> {
    const firebaseKey = await firebaseEnvironmentKey(
      "flow_collaborator_active_portal"
    );
    const getFlowCollaboratorActive = remoteConfig.getBoolean(firebaseKey);
    commit("setFlowCollaboratorActive", getFlowCollaboratorActive);
  },
  async actionBlackFriday({ commit }): Promise<void> {
    const firebaseKey = await firebaseEnvironmentKey("black_friday_portal");
    const getFirebase = remoteConfig.getString(firebaseKey);
    commit("setBlackFriday", JSON.parse(getFirebase));
  },
  async actionPromotionLabel({ commit }): Promise<void> {
    const firebaseKey = await firebaseEnvironmentKey("promotion_label_portal");
    const getFirebase = remoteConfig.getString(firebaseKey);
    commit("setPromotionLabel", JSON.parse(getFirebase));
  },
};

export default {
  state,
  getters,
  mutations,
  actions,
};
